import React from 'react'

export const LoadingText = () => {
  return (
    <div className="px-2 pt-2" style={{ position: 'absolute', top: 0 }}>
      Please wait...
    </div>
  )
}
